import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUnionMembershipStatusService } from './../../Services/unionMembershipStatusService'

export const reducerName = 'unionMembershipStatus';

const initialState = {
  request: false,
  error: null,
  data: null
};

export const getUnionMembershipStatus = createAsyncThunk(
  'unionMembershipStatus/get',
  async (a, { rejectWithValue }) => {
    try {
      
      const response = await getUnionMembershipStatusService();

      return {
        data: response
      };
    } catch (error) {
      return rejectWithValue({
        error: error.message
      })
    }
  }
);


export const unionMembershipStatusReducer = createSlice({
  name: reducerName,
  initialState,
  extraReducers: (builder) => {

    builder.addCase(getUnionMembershipStatus.fulfilled, (state, action) => {
      state.data = action.payload?.data;
      state.request = false;
    })

    builder.addCase(getUnionMembershipStatus.rejected, (state, action) => {
      state.error = action.payload.error;
      state.request = false;
      state.data = null;
    })

    builder.addCase(getUnionMembershipStatus.pending, (state) => {
      state.request = true;
      state.error = null;
      state.data = null;
    })
  }
});

export default unionMembershipStatusReducer.reducer;
